// # cars icons

import CAR_GREEN from '../../../../assets/images/croqui/novo-croqui/carro-verde.png';
import CAR_PURPLE from '../../../../assets/images/croqui/novo-croqui/carro-roxo.png';
import CAR_BLUE from '../../../../assets/images/croqui/novo-croqui/carro-azul.png';
import CAR_RED from '../../../../assets/images/croqui/novo-croqui/carro-vermelho.png';

// # motocycle icons

import MOTORCYCLE_GREEN from '../../../../assets/images/croqui/novo-croqui/moto-verde.png';
import MOTORCYCLE_PURPLE from '../../../../assets/images/croqui/novo-croqui/moto-roxa.png';
import MOTORCYCLE_BLUE from '../../../../assets/images/croqui/novo-croqui/moto-azul.png';
import MOTORCYCLE_RED from '../../../../assets/images/croqui/novo-croqui/moto-azul-escuro.png';

// # truck icons

import TRUCK_GREEN from '../../../../assets/images/croqui/novo-croqui/caminhao-verde.png';
import TRUCK_PURPLE from '../../../../assets/images/croqui/novo-croqui/caminhao-roxo.png';
import TRUCK_BLUE from '../../../../assets/images/croqui/novo-croqui/caminhao-azul.png';
import TRUCK_RED from '../../../../assets/images/croqui/novo-croqui/caminhao-vermelho.png';

// pedestrian icons
import PEDESTRIAN_WHITE from '../../../../assets/images/croqui/novo-croqui/homem-andando (4).png';
import PEDESTRIAN_FEW_WHITE from '../../../../assets/images/croqui/novo-croqui/homem-andando (1).png';
import PEDESTRIAN_FEW_BLACK from '../../../../assets/images/croqui/novo-croqui/homem-andando (2).png';
import PEDESTRIAN_BLACK from '../../../../assets/images/croqui/novo-croqui/homem-andando (3).png';

// others icons

import DOG from '../../../../assets/images/croqui/novo-croqui/dog 1.png';
import HOLE from '../../../../assets/images/croqui/novo-croqui/hole 1.png';
import TREE from '../../../../assets/images/croqui/novo-croqui/tree 1.png';
import TRAFFIC_LIGHT from '../../../../assets/images/croqui/novo-croqui/traffic-light 1.png';
import BARRIER from '../../../../assets/images/croqui/novo-croqui/barrier 1.png';
import TEXT from '../../../../assets/images/croqui/icon-texto.png';
import CAT from '../../../../assets/images/croqui/novo-croqui/gato.png';
import HORSE from '../../../../assets/images/croqui/novo-croqui/cavalo.png';
import YIELD from '../../../../assets/images/croqui/novo-croqui/preferencia.png';
import NO_LEFT from '../../../../assets/images/croqui/novo-croqui/proibido-esquerda.png';
import NO_RIGHT from '../../../../assets/images/croqui/novo-croqui/proibido-direita.png';
import NO_RETURN from '../../../../assets/images/croqui/novo-croqui/proibido-retorno.png';
import NO_WAY from '../../../../assets/images/croqui/novo-croqui/sentido-proibido.png';
import STOP from '../../../../assets/images/croqui/novo-croqui/pare.png';
import UP from '../../../../assets/images/croqui/novo-croqui/seta-cima.png';
import DOWN from '../../../../assets/images/croqui/novo-croqui/seta-baixo.png';
import LEFT from '../../../../assets/images/croqui/novo-croqui/seta-esquerda.png';
import RIGHT from '../../../../assets/images/croqui/novo-croqui/seta-direita.png';
import BUCKET from '../../../../assets/images/croqui/novo-croqui/cacamba.png';

export default {
  cars: [CAR_GREEN, CAR_PURPLE, CAR_BLUE, CAR_RED],
  motorcycles: [
    MOTORCYCLE_PURPLE,
    MOTORCYCLE_BLUE,
    MOTORCYCLE_RED,
    MOTORCYCLE_GREEN,
  ],
  trucks: [TRUCK_BLUE, TRUCK_RED, TRUCK_GREEN, TRUCK_PURPLE],
  pedestrians: [
    PEDESTRIAN_WHITE,
    PEDESTRIAN_FEW_WHITE,
    PEDESTRIAN_FEW_BLACK,
    PEDESTRIAN_BLACK,
  ],
  animals: [DOG, CAT, HORSE],
  plates: [YIELD, STOP, NO_WAY, NO_LEFT, NO_RIGHT, NO_RETURN],
  arrows: [UP, DOWN, LEFT, RIGHT],
  obstacles: [HOLE, TREE, TRAFFIC_LIGHT, BARRIER, BUCKET],
  text: [TEXT],
};

import CROQUI_BASE_IMAGE_URL from '../../../../assets/images/croqui/novo-croqui/bgrua.png';
export { CROQUI_BASE_IMAGE_URL };
